import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { ToastOutletComponent } from '@shared/components/toast-outlet/toast-outlet.component';

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet, ToastOutletComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  title = 'crowdgenix-ui';
}
